import React from 'react';
import styles from './Footer.module.css';

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerLeft}>
          <img src="/assets/images/logo.svg" alt="Rythm" className={styles.footerLogo} />
          <p className={styles.copyright}>&copy; {new Date().getFullYear()} Rythm. All rights reserved.</p>
        </div>
        <div className={styles.footerRight}>
          <div className={styles.legalLinks}>
            <a href="/terms-of-service" className={styles.legalLink}>Terms of Service</a>
            <a href="/privacy" className={styles.legalLink}>Privacy Policy</a>
          </div>
          <div className={styles.socialLinks}>
            <a href="https://discord.gg/ZtH6rZpa8y" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <img src="/assets/images/discord.svg" alt="Discord" />
            </a>
            <a href="https://www.instagram.com/rythmfm/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <img src="/assets/images/instagram.svg" alt="Instagram" />
            </a>
            <a href="https://www.tiktok.com/@rythmfm" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <img src="/assets/images/tiktok.svg" alt="TikTok" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 